export const css = {
	root: 'mm1Llayf',
	atiContainer: 'WszGatIk',
	leftPanel: 'YrBb-aQh',
	rightPanel: 'JDy8sAII',
	classmates: 'OtRS2qbO',
	classmatesTitle: 'apWmhCql',
	' _key': 'class-roster/roster'
};

export default css;
